module.exports = __webpack_public_path__ + "static/media/time.beb5bdb3.svg";